<template>
	<div class="header-popup">
		<div class="header-popup-trigger" ref="triggerRef">
			<slot name="trigger" :is-open="isOpen" />
		</div>

		<Teleport to="body">
			<div
				v-if="isOpen"
				ref="popupRef"
				class="header-popup-body"
			>
				<slot :close="close" />
			</div>
		</Teleport>
	</div>
</template>

<style lang="scss" src="./HeaderPopup.scss" />

<script lang="ts">
import Popup                          from './Popup';
import type { PopupSide, PopupAlign } from './Popup';

export default defineComponent({
	name: 'HeaderPopup',

	props: {
		isOpen: {
			type:    Boolean,
			default: false,
		},

		side: {
			type:    String as PropType<PopupSide>,
			default: 'bottom',
		},

		align: {
			type:    String as PropType<PopupAlign>,
			default: 'start',
		},

		offset: {
			type:    Number,
			default: 4,
		},
	},

	emits: ['close'],
	expose: ['reposition', 'isClickInside'],

	data() {
		return {
			popupInstance: null as Popup | null,
		};
	},

	watch: {
		isOpen: {
			immediate: false,
			handler(value: boolean) {
				if (value === true) {
					// Попап рендерится по v-if — инстанс класса создаём после того, как DOM появится
					this.$nextTick(() => {
						this.attachPopup();
					});
				} else {
					this.detachPopup();
				}
			},
		},
	},

	mounted() {
		if (this.isOpen === true) {
			this.$nextTick(() => {
				this.attachPopup();
			});
		}
	},

	beforeUnmount() {
		this.detachPopup();
	},

	methods: {
		attachPopup(): void {
			const trigger: HTMLElement | undefined = this.$refs.triggerRef as HTMLElement | undefined;
			const popup:   HTMLElement | undefined = this.$refs.popupRef   as HTMLElement | undefined;

			if (trigger === undefined || popup === undefined) return;

			this.popupInstance = new Popup(
				trigger,
				popup,
				this.side,
				this.align,
				this.offset,
				this.close,
			);

			this.popupInstance.attach();
		},

		detachPopup(): void {
			if (this.popupInstance !== null) {
				this.popupInstance.detach();
				this.popupInstance = null;
			}
		},

		reposition(): void {
			if (this.popupInstance !== null) {
				this.popupInstance.reposition();
			}
		},

		close(): void {
			this.$emit('close');
		},

		/**
		 * По попапу ли пришёлся клик. Если попап не отрендерен — false.
		 * Это надо чтобы родительский попап не закрывался раньше времени.
		 * Нужно чтобы родитель оставался открытым в момент клика в дочерний попап
		 */
		isClickInside(event: MouseEvent): boolean {
			const popup = this.$refs.popupRef as HTMLElement | undefined;

			if (!popup) {
				return false;
			} else {
				return popup.contains(event.target as Node);
			}
		},
	},
});
</script>
